"use client"
import { useEffect } from 'react';
import {
  NETWORK_OFFLINE_MESSAGE,
  NETWORK_OFFLINE_TOAST_ID,
  useNetworkStatus,
} from '@/hooks/useNetworkStatus';
import toast from 'react-hot-toast';


interface NetworkStatusProps extends React.PropsWithChildren {

}
export const NetworkStatus = ({ children }: NetworkStatusProps) => {
  const { isOnline } = useNetworkStatus();

  useEffect(() => {
    if (!isOnline) {
      toast.error(NETWORK_OFFLINE_MESSAGE, {
        duration: 5000,
        id: NETWORK_OFFLINE_TOAST_ID,
        style: { minWidth: '380px' },
      });
      return;
    }
    toast.dismiss(NETWORK_OFFLINE_TOAST_ID);
  }, [isOnline])

  return children;
};
